import React, { useEffect } from "react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import "./styles.scss";
import { currencies, DEFAULT_CURRENCY } from "../../constants/default"
import {useHistory} from "react-router";
import { useSelector } from "react-redux";
import { updatePrefsRequest } from "../../redux/prefs/prefsSlice";

const getCurrencySymbol = (locale, currency) => (0).toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim()

const CurrencySwitch = ({ dispatch, cur }) => {
  const { t, i18n } = useTranslation(); // eslint-disable-line
  const prefs = useSelector((state) => state.prefs);

  const history = useHistory();
  // console.log('rendering currency switcher.js')

  const changeCurrency = (event) => {
    // console.log('setting currency from switcher.js')
    dispatch(updatePrefsRequest({ cur: event.target.value, curManuallySet: true }));

    // persist cur in url
    const currentSearchParams = new URLSearchParams(history.location.search);
    currentSearchParams.set("cur", event.target.value); // Update or add the query parameter

    history.push({
      pathname: history.location.pathname, // Keep the current path
      search: currentSearchParams.toString(), // Set the updated query string
    });
  };

  return (
    <ButtonGroup toggle className="currency-switch-group">
      {currencies.map((currency) => (
        <ToggleButton
          key={currency}
          type="radio"
          name="currency"
          value={currency}
          checked={cur === currency}
          onChange={changeCurrency}
          variant="outline-dark"
        >
          <span className="d-none">{getCurrencySymbol(navigator.languages[0] ,currency)}</span>
          <span className="d-inline">{currency}</span>
        </ToggleButton>
      ))}
    </ButtonGroup>
  );
};

const mapStateToProps = ({ vendors, results, ui, currencies, prefs }) => ({
  cur: prefs.cur || DEFAULT_CURRENCY, // Get currency from prefs with fallback
});

export default connect(mapStateToProps)(CurrencySwitch);
